import { createAction } from '@ngrx/store';

export namespace ProfileActions {
  export const logout = createAction('[Profile] logout');
}
